import React from "react";
import { getContentString } from "./chatUtils";
import useIsMobile from "../../hooks/useIsMobile";

const HumanMessageBubble = ({ message }) => {
  const isMobile = useIsMobile();
  const text = getContentString(message);
  if (!text) return null;

  return (
    <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "12px" }}>
      <div
        style={{
          maxWidth: isMobile ? "85%" : "70%",
          padding: "10px 16px",
          borderRadius: "16px 16px 4px 16px",
          backgroundColor: "#825ee7",
          color: "#fff",
          fontSize: "14px",
          lineHeight: 1.5,
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
        }}
      >
        {text}
      </div>
    </div>
  );
};

export default HumanMessageBubble;
